import { Link } from 'react-router-dom';
import styled, { DefaultTheme } from 'styled-components';
import { PhaseType } from 'types/package';

const NAVHEIGHT = '68px';

const getPhaseColor = (phase: PhaseType, theme: DefaultTheme) => {
  switch (phase) {
    case '1':
      return theme.colors.phaseColors.phaseOneDefault;
    case '2':
      return theme.colors.phaseColors.phaseTwoDefault;
    case '3':
      return theme.colors.phaseColors.phaseThreeDefault;
  }
};

export const Wrapper = styled.div`
  background: ${({ theme }) => theme.colors.neutralColors.charcoal};
  position: relative;
  min-height: 100vh;
  ${({ theme }) => theme.breakPoints.desktop} {
    display: flex;
    justify-content: center;
    align-items: flex-start;
  }
`;
export const VideoContainer = styled.div<{ isPlaying: boolean }>`
  width: 100%;
  max-width: 950px;
  display: flex;
  justify-content: center;
  position: relative;
  margin-bottom: 40px;
  iframe {
    width: 100%;
  }
  ${({ theme }) => theme.breakPoints.desktop} {
    margin-bottom: 48px;
  }
`;

export const StyledNav = styled.div`
  position: relative;
  height: ${NAVHEIGHT};
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const StyledAvatarWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 80px;
  position: relative;
  &:after {
    position: absolute;
    bottom: -40px;
    content: '';
    display: block;
    width: 100%;
    height: 2px;
    background-color: ${({ theme }) => theme.colors.neutralColors.white};
    opacity: 0.2;
  }
`;

export const StyledAvatar = styled.img`
  height: 40px;
  width: 40px;
  border-radius: 100%;
  margin-right: 12px;
`;

export const FlexWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  flex-shrink: 1 0 auto;
`;

export const StyledAuthor = styled.p`
  color: ${({ theme }) => theme.colors.textColors.primaryLight};
  font-size: 1.4rem;
  line-height: 2rem;
`;

export const StyledAuthorTitle = styled.p`
  color: ${({ theme }) => theme.colors.textColors.secondaryLight};
  font-size: 1.4rem;
  line-height: 2rem;
`;

export const StyledDescriptionWrapper = styled.div`
  margin: 0 24px;
  margin-bottom: 80px;
  position: relative;

  ${({ theme }) => theme.breakPoints.desktop} {
    margin: 0;
    margin-bottom: 200px;
  }
  &:after {
    position: absolute;
    bottom: -40px;
    content: '';
    display: block;
    width: 100%;
    height: 2px;
    background-color: ${({ theme }) => theme.colors.neutralColors.white};
    opacity: 0.2;
    ${({ theme }) => theme.breakPoints.desktop} {
      display: none;
    }
  }
`;

export const StyledSectionHeader = styled.h2`
  font-size: 1.8rem;
  line-height: 2.4rem;
  margin-bottom: 24px;
  color: ${({ theme }) => theme.colors.textColors.secondaryLight};
`;

export const StyledIconWrapper = styled.div<{ phase: PhaseType }>`
  height: 40px;
  width: 40px;
  background: ${({ theme }) => theme.colors.neutralColors.darkerGray};
  border-radius: 100%;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 12px;
  svg {
    color: ${({ theme, phase }) => getPhaseColor(phase, theme)};
    font-size: 2.5rem;
    path {
      stroke-width: 1px;
    }
  }
`;

export const StyledDescriptionField = styled.p`
  font-size: 1.6rem;
  line-height: 2.4rem;
  max-width: 600px;
  color: ${({ theme }) => theme.colors.textColors.primaryLight};
`;

export const StyledHeading = styled.h1`
  font-size: 3.6rem;
  line-height: 4rem;
  font-family: 'Ivar Regular Display';
  margin-bottom: 24px;
  color: ${({ theme }) => theme.colors.textColors.primaryLight};
  ${({ theme }) => theme.breakPoints.desktop} {
    margin-bottom: 32px;
  }
`;

export const StyledLinkButton = styled(Link)`
  background: transparent;
  border: none;
  cursor: pointer;
  position: absolute;
  left: 27px;
  top: 50%;
  transform: translateY(-50%);
`;
export const StyledContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  ${({ theme }) => theme.breakPoints.desktop} {
    flex-direction: row;
  }
`;

export const StyledCardWrapper = styled.div`
  padding: 0 24px;
  padding-bottom: 80px;
  background: ${({ theme }) => theme.colors.neutralColors.charcoal};
  ${({ theme }) => theme.breakPoints.desktop} {
    width: 450px;
    flex: 0 0 450px;
    height: 100%;
    background: ${({ theme }) => theme.colors.neutralColors.charcoal};
    padding: ${NAVHEIGHT} 40px;
  }
`;

export const StyledCloseMenuButton = styled.button`
  display: none;
  ${({ theme }) => theme.breakPoints.desktop} {
    display: block;
    background: none;
    position: absolute;
    right: 29px;
    top: 29px;
    border: none;
    cursor: pointer;
  }
`;
